"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SignaturePopup_1 = require("./SignaturePopup");
var test_json_data_1 = require("./test_json_data");
var sweetalert2_1 = __importDefault(require("sweetalert2"));
console.log("Wrapper");
new SignaturePopup_1.SignaturePopup();
var submit_button = document.getElementById("submit_form_button");
if (submit_button) {
    submit_button.addEventListener("click", submit);
}
if (process.env.DEBUG === "true") {
    window.pdf.json_data = test_json_data_1.test_json_data;
}
var secondary_json_data = {
    slug: process.env.SLUG ? process.env.SLUG : "collectiv",
    email_template_id: process.env.SLUG,
    acronym: process.env.ACRONYM_SLUG,
    pack_id: "collectiv_application",
    advisor_email: "admissions@collectiv.edu",
    v2_pdf_upload_code: "ENR",
    form_type: "edularCore",
    version: "v3",
    forms: [
        {
            url: process.env.BASE_DOMAIN + "?form_id=application_admissions",
            title: "Application Admissions"
        }
    ]
};
var STANDALONE_CUSTOM_TASK_END_POINTS = {
    submit: "/submit/standalone",
    answer: "custom-task/answer"
};
function submit() {
    return __awaiter(this, void 0, void 0, function () {
        var check, page, textPage, SUBMIT_TEXT, standaloneRequest, endpoint, _a, status_1, body, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    console.log("submit");
                    console.log(window.pdf.json_data);
                    return [4, window.pdf.validate()];
                case 1:
                    check = _b.sent();
                    if (!check) {
                        alert("Please check errors");
                        return [2];
                    }
                    document.getElementById("root").style.display = "none";
                    page = document.getElementById("success_page");
                    textPage = document.getElementById("wait_text");
                    SUBMIT_TEXT = "Please wait while we process your information.";
                    standaloneRequest = {
                        taskUri: "",
                        payload: {}
                    };
                    if (window.pdf.json_data.type === "student") {
                        endpoint = window.pdf["model"].urlQueryParams
                            ? STANDALONE_CUSTOM_TASK_END_POINTS.answer
                            : STANDALONE_CUSTOM_TASK_END_POINTS.submit;
                        standaloneRequest.taskUri = endpoint.startsWith("/")
                            ? endpoint.substring(1)
                            : "/" + endpoint;
                        standaloneRequest.payload = __assign(__assign(__assign({}, window.pdf.json_data), { full_name: ((window.pdf.json_data.first_name || "") + " " + (window.pdf.json_data.middle_name || "") + " " + (window.pdf.json_data.last_name || ""))
                                .trim()
                                .replace(/\s+/g, " ") }), secondary_json_data);
                    }
                    else {
                        standaloneRequest.taskUri = STANDALONE_CUSTOM_TASK_END_POINTS.answer.startsWith("/")
                            ? STANDALONE_CUSTOM_TASK_END_POINTS.answer.substring(1)
                            : "/" + STANDALONE_CUSTOM_TASK_END_POINTS.answer;
                        standaloneRequest.payload = __assign({}, window.pdf.json_data);
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    textPage.textContent = SUBMIT_TEXT;
                    page.style.display = "flex";
                    page.style.zIndex = "99999";
                    return [4, sendRequest(standaloneRequest.payload, "/v3/" + standaloneRequest.taskUri)];
                case 3:
                    _a = _b.sent(), status_1 = _a.status, body = _a.body;
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    if (status_1 !== 200) {
                        document.getElementById("root").style.display = "block";
                        sweetalert2_1.default.fire({
                            icon: "warning",
                            title: "Error while submitting the form.",
                            text: "Something happened while submitting your form, please check. " + JSON.stringify(body),
                            width: "500px"
                        });
                        window.pdf.json_data.errors = body === null || body === void 0 ? void 0 : body.errors;
                        window.pdf["model"].dispatcher.dispatch();
                        return [2];
                    }
                    showSuccessPage(body._id, page, textPage, window.pdf.json_data.type);
                    return [3, 5];
                case 4:
                    error_1 = _b.sent();
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    sweetalert2_1.default.fire({
                        icon: "error",
                        title: "Server down.",
                        text: "Our servers are down. Please try again later.",
                        width: "500px"
                    }).then(function () {
                        window.location.assign(process.env.BASE_DOMAIN);
                        location.reload();
                    });
                    return [3, 5];
                case 5: return [2];
            }
        });
    });
}
function sendRequest(json_data, url) {
    return __awaiter(this, void 0, void 0, function () {
        var rawResponse, body;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch("" + process.env.API_DOMAIN + url, {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(json_data)
                    })];
                case 1:
                    rawResponse = _a.sent();
                    return [4, rawResponse.json()];
                case 2:
                    body = _a.sent();
                    console.log(rawResponse.status);
                    console.log(body);
                    return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function showSuccessPage(id, page, textPage, type) {
    return __awaiter(this, void 0, void 0, function () {
        var GENERATE_PDF, _a, staffMessage, studentMessage, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    GENERATE_PDF = "Please wait your PDF file is being generated.";
                    _a = [
                        "The Application form has been sent.",
                        "Thank you for submit your application. An advisor will contact you soon."
                    ], staffMessage = _a[0], studentMessage = _a[1];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    textPage.textContent = GENERATE_PDF;
                    page.style.display = "flex";
                    page.style.zIndex = "99999";
                    return [4, waitUntilJobComplete(id)];
                case 2:
                    _b.sent();
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    sweetalert2_1.default.fire({
                        icon: "success",
                        title: "Request sent",
                        text: type === "student" ? studentMessage : staffMessage,
                        width: "500px"
                    }).then(function () {
                        if (window.history.replaceState) {
                            window.history.replaceState({}, document.title, window.location.pathname);
                        }
                        window.location.assign(process.env.BASE_DOMAIN);
                        location.reload();
                    });
                    page.innerHTML = "<strong>Generating PDF files completed.</strong>";
                    return [3, 4];
                case 3:
                    e_1 = _b.sent();
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    sweetalert2_1.default.fire({
                        icon: "error",
                        title: "Error while generating the pdf's.",
                        text: "Something happened while generating the pdf forms, please try again later.",
                        width: "500px"
                    }).then(function () {
                        if (window.history.replaceState) {
                            window.history.replaceState({}, document.title, window.location.pathname);
                        }
                        window.location.assign(process.env.BASE_DOMAIN);
                        location.reload();
                    });
                    page.innerHTML = "<strong>Error Generating PDF files.</strong>";
                    console.log(e_1);
                    return [3, 4];
                case 4: return [2];
            }
        });
    });
}
function waitUntilJobComplete(id) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2, new Promise(function (resolve, reject) {
                    var interval_id = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                        var status, body, r, e_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4, sendRequest({}, "/check/" + id)];
                                case 1:
                                    r = _a.sent();
                                    status = r.status;
                                    body = r.body;
                                    return [3, 3];
                                case 2:
                                    e_2 = _a.sent();
                                    clearInterval(interval_id);
                                    clearTimeout(timeout_id);
                                    reject(e_2);
                                    return [2];
                                case 3:
                                    console.log(body.jobs);
                                    if (status !== 200) {
                                        clearInterval(interval_id);
                                        clearTimeout(timeout_id);
                                        reject("Got status code not 200 from API");
                                    }
                                    if (body.jobs.status === "done") {
                                        clearInterval(interval_id);
                                        clearTimeout(timeout_id);
                                        resolve();
                                    }
                                    return [2];
                            }
                        });
                    }); }, 3000);
                    var timeout_id = setTimeout(function () {
                        clearInterval(interval_id);
                        reject(new Error("1 minute timeout reached"));
                    }, 60 * 1500);
                })];
        });
    });
}
//# sourceMappingURL=data:application/json;base64,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